import stringUtils from '../../utils/string';
import { isNullOrUndefined } from '../../predicates/type';

window.__REACT__TOOLTIP = window.__REACT__TOOLTIP || [];

export const _addInstance = (instance) => {
	window.__REACT__TOOLTIP.push(instance);
};

export const _removeLastInstance = () => {
	if (window.__REACT__TOOLTIP.length === 0) {
		return;
	}

	window.__REACT__TOOLTIP.splice(window.__REACT__TOOLTIP.length - 1, 1);
};

export const _getLastInstance = () => {
	if (window.__REACT__TOOLTIP.length === 0) {
		return null;
	}

	return window.__REACT__TOOLTIP[window.__REACT__TOOLTIP.length - 1];
};

export const closeActiveTooltip = () => {
	const tooltipInstance = _getLastInstance();

	if (!isNullOrUndefined(tooltipInstance)) {
		tooltipInstance.close();
	}
};

export const closeLastTooltipByName = (groupName) => {
	const tooltipInstance = _getLastInstance();

	if (tooltipInstance !== null && !stringUtils.isNullOrEmpty(groupName) && tooltipInstance.groupName !== groupName) {
		tooltipInstance.close();
	}
};
